import { gatewayInstance } from "../axiosInstance";

export const getChargeTypesByHeaders = async (headerIds) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/charge-Type/headers",
      headerIds,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching charge types by headers:", error);
    throw error;
  }
};


export const removeCharges = async (payload, username, companyId) => {
  try {
    const response = await gatewayInstance.post(
      `/financeservice/charge-removal`,
      payload,
      {
        params: {
          user: username,
          companyId: companyId,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error removing charges:", error);
    throw error;
  }
};
